import React from 'react'
import PropTypes from 'prop-types'
import GoodPriceForOrder from '@mobileComponents/catalog/CatalogGoodItem/CatalogGoodInfo/GoodPriceAndChanger/GoodPriceForOrder/GoodPriceForOrder'
import Button from '@shared/Button/Button'
import { ElementSizeType, successButtonColorBlackLight } from '@styles/theme-const'
import * as S from './GoodPriceAndChanger.styled'
import GoodPriceDescription from './GoodPriceDescription/GoodPriceDescription'
import BasketController from '../../../BasketController/BasketController'
import { FavoriteIndicateMobile } from 'src/features/favorite/ui/favorite-indicate-mobile'

const GoodPriceAndChanger = ({ shipment, good, toggleAnaloguesPage, isShowedFixPrice }) => {
    return (
        <S.Container>
            {isShowedFixPrice ? (
                <GoodPriceForOrder count={good.count} fixPrice={good.fixPrice} />
            ) : (
                <GoodPriceDescription
                    shipment={shipment}
                    availableStocksCount={good.availableStocksCount}
                    isAvailableDeliveryByErecipe={good.isAvailableDeliveryByErecipe}
                    isSelectedStock={!!shipment.stockId}
                    deliveryStatus={good.deliveryStatus}
                    goodId={good.webData.goodId}
                    isAvailable={good.isAvailable}
                    isAvailableOnStock={good.isAvailableOnStock}
                    minPrice={good.minPrice}
                    stockPrice={good.stockPrice}
                    deliveryPrice={good.deliveryPrice}
                />
            )}
            <S.BottomBlock>
                <FavoriteIndicateMobile goodId={good.webData.goodId} />
                {good.analoguesQty ? (
                    <S.AnaloguesButtonContainer>
                        <Button
                            elementSizeTypeValue={ElementSizeType.small}
                            colors={successButtonColorBlackLight}
                            clickHandler={toggleAnaloguesPage}>
                            Аналоги <S.AnaloguesSpanCount>({good.analoguesQty})</S.AnaloguesSpanCount>
                        </Button>
                    </S.AnaloguesButtonContainer>
                ) : (
                    <React.Fragment />
                )}
                <BasketController good={good} webId={good.webData.webId} shipment={shipment} />
            </S.BottomBlock>
        </S.Container>
    )
}

GoodPriceAndChanger.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
    shipment: PropTypes.any,
    // eslint-disable-next-line react/require-default-props
    groupId: PropTypes.number.isRequired,
    // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
    good: PropTypes.any,
    toggleAnaloguesPage: PropTypes.func,
    // eslint-disable-next-line react/no-unused-prop-types
    isShowedFixPrice: PropTypes.bool.isRequired
}
GoodPriceAndChanger.defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    groupId: 0
}
export default GoodPriceAndChanger
